import axios from 'axios';
import { from } from 'rxjs';

import { emptyObject } from 'ui-components/default-props/empty';

export const getPresets = () => {
  const getAndTransform = axios.get('/presets').then(({ data }) => data);

  const presets$ = from(getAndTransform);
  return presets$;
};

export const createOrUpdatePreset = (presetId, preset) => {
  let url = '/presets';
  if (presetId) {
    url += `/${presetId}`;
  }
  const getAndTransform = axios.post(url, preset).then(({ data }) => data || emptyObject);

  const preset$ = from(getAndTransform);
  return preset$;
};

export const deletePreset = (presetId) => {
  const deleted = axios.delete(`/presets/${presetId}`);
  const preset$ = from(deleted);
  return preset$;
};
